import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { CardComponent } from '@libs/layouts/card';
import { SideNavComponent } from '@libs/layouts/side-nav';
import { LogoComponent } from '@libs/logo/components';

import { LoggedInGuard, LoggedOutGuard } from '@app/common/guards';


export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: '',
    data: {
      fsNav: { root: true },
    },
    children: [
      {
        path: '',
        component: SideNavComponent,
        children: [
          {
            canActivate: [LoggedInGuard],
            path: 'account',
            loadChildren: () => import('./account').then((m) => m.AccountModule),
          },
          {
            canActivate: [LoggedInGuard],
            path: 'admin',
            loadChildren: () => import('./admin').then((m) => m.AdminModule),
            data: {
              fsNav: { root: true },
            },
          },
          {
            canActivate: [LoggedInGuard],
            path: 'system',
            loadChildren: () => import('./system').then((m) => m.SystemModule),
            data: {
              fsNav: { root: true },
            },
          },
          {
            canActivate: [LoggedInGuard],
            path: 'organization',
            loadChildren: () => import('./environment').then((m) => m.EnvironmentModule),
          },
          {
            canActivate: [LoggedInGuard],
            path: 'terms-privacy',
            loadChildren: () => import('./terms-privacy').then((m) => m.TermsPrivacyModule),
          },
          {
            canActivate: [LoggedInGuard],
            path: 'dashboard',
            loadChildren: () => import('./dashboard').then((m) => m.DashboardModule),
            data: {
              fsNav: { root: true },
            },
          },
          {
            canActivate: [LoggedInGuard],
            path: 'staff',
            loadChildren: () => import('./staff').then((m) => m.StaffModule),
            data: {
              fsNav: { root: true },
            },
          },
          {
            path: 'notfound',
            loadChildren: () => import('@libs/not-found').then((m) => m.NotFoundModule),
          },
        ],
      },
    ],
  },
  {
    path: '',
    component: CardComponent,
    children: [
      {
        path: 'signin',
        canActivate: [LoggedOutGuard],
        loadChildren: () => import('./signin').then((m) => m.SigninModule),
        data: { bodyClass: 'body-card body-signin' },
      },
      {
        path: 'invite',
        loadChildren: () => import('./invite/invite.module').then((m) => m.InviteModule),
        data: { bodyClass: 'body-card' },
      },
      {
        // The Allow page Claude sends a person to, and where a broken request lands
        path: 'oauth',
        loadChildren: () => import('@firestitch/oauth')
          .then((m) => m.fsOAuthRoutes({ canActivate: [LoggedInGuard], logo: LogoComponent })),
        data: { bodyClass: 'body-card' },
      },
      {
        path: 'password/change',
        children: [
          {
            path: '',
            loadChildren: () => import('@firestitch/password-reset').then((m) => m.FsForcePasswordChangeModule),
          },
        ],
      },
    ],
  },
  {
    path: 'blank',
    component: CardComponent,
  },
  { 
    path: '**',     
    redirectTo: () => {
      return '/notfound';
    },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        useHash: (+document.location.port === 8080 || document.location.protocol === 'file:'),
        preloadingStrategy: PreloadAllModules,
      },
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
